import AwarenessCampaignContent from 'schemas/metadata/content/AwarenessCampaignContent';
import AwarenessRulesContent from 'schemas/metadata/content/AwarenessRulesContent';
import VaccinationsCampaignContent from 'schemas/metadata/content/VaccinationsCampaignContent';
import VaccinationsRulesContent from 'schemas/metadata/content/VaccinationsRulesContent';
import { CampaignContent, RulesContent } from 'schemas/Content.schema';
import { CAMPAIGN_TYPE_AWARENESS, CampaignType } from 'schemas/enums/campaigns';
import { RuleType } from 'schemas/IterationRule.schema';

export function getCampaignContent(campaignType?: CampaignType): CampaignContent {
  if (campaignType === CAMPAIGN_TYPE_AWARENESS) {
    return AwarenessCampaignContent;
  }
  return VaccinationsCampaignContent;
}

export function getRulesContent(campaignType?: CampaignType): RulesContent[] {
  if (campaignType === CAMPAIGN_TYPE_AWARENESS) {
    return AwarenessRulesContent;
  }
  return VaccinationsRulesContent;
}

export function getRulesContentByType(ruleType: RuleType, campaignType?: CampaignType): RulesContent | undefined {
  const rulesContent = getRulesContent(campaignType);
  return rulesContent.find((rule) => rule.type === ruleType);
}

export function getFilterRulesContent(rulesContent: RulesContent[]): RulesContent | undefined {
  return rulesContent.find((rule) => rule.type === 'F');
}

export function getSuppressionRulesContent(rulesContent: RulesContent[]): RulesContent | undefined {
  return rulesContent.find((rule) => rule.type === 'S');
}

export function getRoutingRulesContent(rulesContent: RulesContent[]): RulesContent | undefined {
  return rulesContent.find((rule) => rule.type === 'R');
}
